import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  // 兼容旧链接 /icp/*
  { path: '/icp', redirect: '/' },
  { path: '/icp/*', redirect: to => '/' + to.params.pathMatch },

  // ============ ICP 信息发布站 ============
  {
    path: '/',
    component: () => import('@/layouts/IcpLayout.vue'),
    children: [
      { path: '', name: 'icp-home', component: () => import('@/views/icp/Home.vue') },
      { path: 'list', name: 'icp-list', component: () => import('@/views/icp/PostList.vue') },
      { path: 'post/:id', name: 'icp-detail', component: () => import('@/views/icp/PostDetail.vue') },
      { path: 'publish', name: 'icp-publish', meta: { auth: true }, component: () => import('@/views/icp/PublishPost.vue') },
      { path: 'user', name: 'icp-user', meta: { auth: true }, component: () => import('@/views/icp/UserCenter.vue') },
      { path: 'agreement', name: 'icp-agreement', component: () => import('@/views/common/Agreement.vue') },
      { path: 'privacy', name: 'icp-privacy', component: () => import('@/views/common/Privacy.vue') }
    ]
  },

  // ============ EDI 店铺街商城站 ============
  {
    path: '/edi',
    component: () => import('@/layouts/EdiLayout.vue'),
    children: [
      { path: '', name: 'edi-home', component: () => import('@/views/edi/Home.vue') },
      { path: 'shops', name: 'edi-shops', component: () => import('@/views/edi/ShopStreet.vue') },
      { path: 'shop/:id', name: 'edi-shop', component: () => import('@/views/edi/ShopDetail.vue') },
      { path: 'product/:id', name: 'edi-product', component: () => import('@/views/edi/ProductDetail.vue') },
      { path: 'cart', name: 'edi-cart', component: () => import('@/views/edi/Cart.vue') },
      { path: 'apply', name: 'edi-apply', meta: { auth: true }, component: () => import('@/views/edi/ShopApply.vue') },
      { path: 'user', name: 'edi-user', meta: { auth: true }, component: () => import('@/views/edi/UserCenter.vue') },
      { path: 'agreement', name: 'edi-agreement', component: () => import('@/views/common/Agreement.vue') },
      { path: 'privacy', name: 'edi-privacy', component: () => import('@/views/common/Privacy.vue') }
    ]
  },

  // 登录注册（两站共用）
  { path: '/login', name: 'login', component: () => import('@/views/common/Login.vue') },
  { path: '/register', name: 'register', component: () => import('@/views/common/Register.vue') }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior: () => ({ x: 0, y: 0 })
})

router.beforeEach((to, from, next) => {
  if (to.meta.auth && !store.getters.isLogin) {
    next({ path: '/login', query: { redirect: to.fullPath } })
  } else {
    next()
  }
})

export default router
